import { observable, action } from 'mobx'
import api from '../api'
import errorStore from './errorStore'
import translationStore from './translationStore'

class CategoriesStore {

  @observable mainCategories = []
  @observable categories = []
  @observable inProgress = false
  @observable errors = undefined

  constructor() {
    this.fetchCategories()
  }

  @action.bound fetchCategories() {

    const categories = action((resCategories) => this.categories = resCategories)
    const mainCategories = res => res.filter( category => !category.parent)

    this.inProgress = true
    this.errors = undefined
    return api.Categories.getAll()
      .then(categories)
      .then(mainCategories)
      .then(action(resCategories => this.mainCategories = resCategories))
      .catch(action(err => {
        this.errors = err.response && err.response.body && err.response.body.errors
        errorStore.displayError(translationStore.translate('fetch_categories_error'))
      }))
      .finally(action('Categories fetch completed' ,() => { this.inProgress = false }))
  }
}

export default new CategoriesStore()



// WEBPACK FOOTER //
// ./src/stores/categoriesStore.js